export enum PensionPlan {
  STANDARD_BEFORE = 'STANDARD_BEFORE',
  PLUS_BEFORE = 'PLUS_BEFORE',
  SURPLUS_BEFORE = 'SURPLUS_BEFORE',

  STANDARD_AFTER = 'STANDARD_AFTER',
  PLUS_AFTER = 'PLUS_AFTER',
  SURPLUS_AFTER = 'SURPLUS_AFTER'
}
